import { useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { YOUTUBE_ID } from "@/lib/site";

export const VideoSection = () => {
  const [loaded, setLoaded] = useState(false);
  const thumb = `https://i.ytimg.com/vi/${YOUTUBE_ID}/maxresdefault.jpg`;

  return (
    <section
      id="video"
      data-testid="video-section"
      className="relative bg-[#1A1714] pt-16 pb-24 md:pt-20 md:pb-32"
    >
      <div className="container-lr relative">
        <div className="max-w-2xl mx-auto text-center">
          <div className="flex items-center justify-center gap-4">
            <span className="gold-rule" />
            <p className="eyebrow text-gold">See the System in Action</p>
            <span className="gold-rule" />
          </div>
          <h2 className="mt-6 font-serif font-semibold tracking-display text-ivory text-3xl md:text-4xl lg:text-5xl leading-[1.1]">
            Understand the process in plain English.
          </h2>
          <p className="mt-5 text-taupe text-base md:text-lg leading-relaxed">
            A short, plain-language walkthrough of the ideas behind Infinite Banking and the Legacy Life approach to building financial control.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          data-testid="video-embed"
          className="relative mt-14 mx-auto max-w-4xl aspect-video rounded-card overflow-hidden border border-gold/35 bg-black shadow-[0_30px_70px_-45px_rgba(0,0,0,0.7)]"
        >
          {loaded ? (
            <iframe
              className="absolute inset-0 h-full w-full"
              src={`https://www.youtube-nocookie.com/embed/${YOUTUBE_ID}?autoplay=1&rel=0`}
              title="Legacy Life & Retirement Overview"
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              data-testid="video-iframe"
            />
          ) : (
            <button
              type="button"
              onClick={() => setLoaded(true)}
              data-testid="video-play-button"
              aria-label="Play overview video"
              className="group absolute inset-0 flex flex-col items-center justify-center gap-5 focus-ring"
            >
              <img
                src={thumb}
                alt="Overview video"
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover opacity-60 transition-transform duration-700 group-hover:scale-[1.03] group-focus-visible:scale-[1.03] motion-reduce:transition-none motion-reduce:group-hover:scale-100 motion-reduce:group-focus-visible:scale-100"
                onError={(e) => { e.currentTarget.style.display = "none"; }}
              />
              <span className="absolute inset-0 bg-legacy/40" />
              <span className="relative inline-flex h-20 w-20 items-center justify-center rounded-full bg-gold text-legacy transition-transform duration-300 group-hover:scale-105">
                <span className="absolute inset-0 rounded-full bg-gold/40 animate-ping [animation-duration:2.6s]" />
                <Play size={28} className="ml-1 relative z-10" fill="currentColor" />
              </span>
              <span className="relative rounded-full bg-legacy/80 px-4 py-2 text-ivory text-[0.78rem] font-semibold tracking-[0.18em] uppercase">
                Play Overview
              </span>
            </button>
          )}
        </motion.div>
      </div>
    </section>
  );
};
